import styled from 'styled-components';

import { Typography } from '@mui/material';
import { ReactComponent as PageImage } from '../assets/icons/500.svg';
import { colors } from '../theme';

const NotFound = (props) => {
    return (
        <PageContainer>
            <PageImage />
            <TextContainer>
                <Typography variant="h4">Error 500</Typography>
                <Typography variant="h2">Internal Server Error</Typography>
                <Typography>We're experiencing an internal server problem or an unexpected error has occurred.</Typography>
                <Typography sx={{ mt: '1em' }}>
                    Please try to refresh the browser or contact
                    <a href="mailto:ttportal@bcit.ca">ttportal@bcit.ca</a>
                    if the problem persists.
                </Typography>
            </TextContainer>
        </PageContainer>
    );
};

export default NotFound;

const PageContainer = styled.div`
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.bg};

    svg {
        width: 30vw;
        height: auto;
    }

    h4 {
        text-transform: uppercase;
        font-weight: 700;
        color: ${colors.blue.main};
    }

    h2 {
        font-size: 40px;
        margin-bottom: 0.5em;
    }

    p {
        font-size: 20px;
    }

    a {
        text-decoration: none;
        color: ${colors.blue.main};
        font-weight: 700;
        margin: 0 5px;
    }
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 2em;
    max-width: 35vw;
`;
